var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 9.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 6.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 6.5,
    r: 1,
    stroke: "#CFCFCF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 3.5,
    x2: 8.5,
    y2: 1.5,
    stroke: "#CFCFCF",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 3.5,
    x2: 9.5,
    y2: 3.5,
    stroke: "#CFCFCF",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapes);
export default __webpack_public_path__ + "static/media/grapes.b74bf48b.svg";
export { ForwardRef as ReactComponent };